<!--
Rules:
* Can only select spaces from a single business

If:required
  At least 1 item must be selected at all times

Notes: Archived spaces can cause issues here:
A contact was shared with an archived space, that space no longer shows up
-->
<template>
<div>
  <v-select
    v-if='withSelect'
    ref='spacePicker'
    dense clearable
    v-model='selected'
    :label='label'
    :items='spaces'
    :multiple='multiple'
    :value-comparator='compare'
    :menu-props="{ bottom: true, offsetY: true }"
    v-bind='attrs'
    item-text='title'
    item-value='id' >

    <template v-slot:selection="{ item }">
      <v-chip>
        <v-avatar :size=28 color='gray' class='mr-1 elevation-4' :color='item.color' >
          <v-img v-if='item.logo_picture' :src='item.logo_picture'  >
          </v-img>
        </v-avatar>
        {{item.title}}
      </v-chip>
    </template>

    <template slot='item' slot-scope="props" >
        <v-list-tile-action>
          <v-avatar :size=28 :color='props.item.color' >
            <v-img v-if='props.item.logo_picture' :src='props.item.logo_picture'  >
            </v-img>
          </v-avatar>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>
            <!-- {{computedSelected}} -->
            # {{props.item.id}}:
            {{props.item.title}}
          </v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action >
          <v-icon v-if='isSelected(props.item)' >check</v-icon>
          <v-icon v-else >check_box_outline_blank</v-icon>
        </v-list-tile-action>
    </template>

    <template v-slot:append-item>
      <v-divider class="mb-2"></v-divider>
      <v-btn @click='$refs.spacePicker.blur()' text flat small block >Done</v-btn>
    </template>
  </v-select>
  <!-- {{value}} -->
  <v-card dense subheader v-else flat class='pa-0' >
    <v-subheader class='overline my-0' >{{label}}</v-subheader>
    <!-- {{business}} -->
    <v-layout row wrap >
      <v-flex v-for='(space, index) in spaces' :key='`${space.id}-${index}`' >
        <v-list dense class='pa-0' >
          <v-list-tile :key='space.id'
            @click='toggleSpace(space)'
            :class='{"grey--text": !canEditSpace(space) }' >

            <v-list-tile-action v-if='readOnly' >
              <v-icon v-if='isSelected(space)' >check</v-icon>
            </v-list-tile-action>
            <v-list-tile-action v-else >
              <v-icon v-if='isSelected(space)' >check_box</v-icon>
              <v-icon v-else >check_box_outline_blank</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title >{{space.title}}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-avatar >
              <v-avatar :size=28 class='mr-1 elevation-4' :color='space.color' dark >
                <v-img v-if='space.logo_picture' :src='space.logo_picture'  >
                </v-img>
                <span v-else-if='space.title' v-text='space.title[0]' />
              </v-avatar>
            </v-list-tile-avatar>
          </v-list-tile>
          <!-- <v-divider :key='`div-${space.id}`' ></v-divider> -->
        </v-list>
      </v-flex>
    </v-layout>
    <div v-if='required && !readOnly' class='caption info--text ml-3 mt-1' >
      * required: at least one space must be selected
    </div>
  </v-card>
</div>
</template>
<script>
export default {
  name: 'SpacePicker',
  props: {
    value: { default: () => { return [] } },
    label: { type: String, default: 'Spaces' },
    multiple: { type: Boolean, default: true },
    withSelect: { type: Boolean, default: true },
    readOnly: { type: Boolean, default: false },
    isOwner: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    attrs: { type: Object, default: () => {} },
    touch: { type: Number, default: 0 }
  },
  data () {
    return {
      selected: []
    }
  },
  mounted () {
    this.dotouch()
  },
  watch: {
    touch () {
      this.dotouch()
    },
    value: {
      immediate: true,
      handler () { this.dotouch() }
    },
    selected () {
      // this.$emit('selected', this.selected)
      this.$emit('input', this.selected)
      // this.$emit('input:object', this.selectedSpaceIds)
    }
  },
  methods: {
    compare (a, b) {
      if (a.id) { a = a.id }
      if (b.id) { b = b.id }
      if (a && b) {
        return parseInt(a) === parseInt(b)
      }
      return false
    },
    isSelected (item) {
      let vm = this
      if (this.selected && this.selected.length > 0) {
        let index = this.selected.findIndex((selected) => {
          return vm.compare(selected, item)
          // if (this.attrs && this.attrs.returnObject === true) {
          //   return selected.id === item.id
          // } else {
          //   return parseInt(selected) === parseInt(item.id)
          // }
        })
        return index !== -1
      }
      return false
    },
    canEditSpace (space) {
      if (this.business && this.business !== space.business) { return false }
      return true
    },
    toggleSpace (space) {
      if (this.business && this.business !== space.business) { return }
      if (this.readOnly) { return }
      let index = this.selected.findIndex((id) => {
        return (id === space.id)
      })
      if (index === -1) {
        this.selected.push(space.id)
      } else {
        let isRequired = (this.required === true && this.selected && this.selected.length === 1)
        // console.log(isRequired, this.required, this.selected.length)
        if (!isRequired) {
          this.selected.splice(index, 1)
        }
      }
    },
    dotouch () {
      if (this.value) {
        // coerce to int
        this.selected = this.value
      }
    }
  },
  computed: {
    spaces () {
      let spaces = this.$store.getters.spaces
      if (this.isOwner === true) {
        return spaces.filter((space) => {
          return space.role === 'Owner'
        })
      }
      return spaces
    },
    business () {
      if (this.computedSelected && this.computedSelected.length > 0) {
        return this.computedSelected[0].business
      }
      return null
    },
    computedSelected () {
      return this.spaces.filter((space) => {
        return this.value.indexOf(space.id) !== -1
      })
    },
    selectedSpaceIds () {
      if (this.selected) {
        return this.selected.map((space) => {
          return space.id
        })
      }
      return []
    }
  }
}
</script>



// WEBPACK FOOTER //
// SpacePicker.vue?ba57b874